<template>
    <div class="video">
        <v-row>
            <v-col>
                <LazyYoutube
                    ref="lazyVideo"
                    :src="'https://www.youtube.com/embed/'+video"
                    :autoplay="true"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { LazyYoutube, LazyVimeo } from "vue-lazytube";

export default {
    name: "YourComponent",
    props: ["data", "status"],
	data(){
		return{
			video:null
		}
	},
    components: {
        LazyYoutube,
        LazyVimeo,
    },
    watch: {
        status(val) {
            if (!val) {
                this.$refs["lazyVideo"]["stopVideo"]();
            } else {
                this.$refs["lazyVideo"]["playVideo"]();
            }
        },
		'data.id'(val){
				if (val) {
					this.video=val
				}
		}
    },
	mounted(){
		if (this.data && this.data.id) {
			this.video = this.data.id
		}
	}
};
</script>
